import {useParams} from 'react-router-dom'
import styles from './RequestAbout.module.scss'
import {ProjectCard} from 'modules/project'
import {Text} from 'common/components'
import { Button } from 'common/components/V2'
import {
  VariationRequestStatusPanel,
  VariationRequestDetails,
  VariationReview,
  VariationRequestForecast,
  VariationRequestEstablishmentFee,
  VariationRequestLineFee,
  VariationRequestFacilityLimit2,
  VariationDataConfirm,
  isMilestonePassed,
} from '..'
import {useGetVariationRequest} from '../api.variation'
import { BeforeAfterVariation } from './BeforeAfter.variation'

const isDuringConfirmProcess = (status:string):boolean => (
  !!status && 
  [
    'ready-to-open', 
    'financial-controller-review',
    'confirm-open'
  ].includes(status)
)

const CardsStackRequest = ({request}:{
  request:any
}) => {
  
  const isDuringConfirm = isDuringConfirmProcess(request.status)

  return (
    <>
      <Text mt={isDuringConfirm ? 56:0} mb={24} size="md" weight="medium" style={{color: '#000'}}>
        <Button className='tab' $size='small' $color='charcoal'>
          Variation Request Data
        </Button>
      </Text>
      <BeforeAfterVariation request={request} />
      <div className={styles.grid}>
        <div className={styles.column}>
          
          <VariationRequestDetails request={request} />
          { !!isMilestonePassed('forecast-created', request) && 
            <VariationRequestEstablishmentFee
              isDuringConfirm={isDuringConfirm}
              showCard={isMilestonePassed('establish-fee-checked', request)}
            />
          }
          { !!isMilestonePassed('establish-fee-checked', request) &&
            <VariationRequestLineFee
              isDuringConfirm={isDuringConfirm}
              showCard={isMilestonePassed('line-fee-checked', request)}
            />
          }
          { !!isMilestonePassed('line-fee-checked', request) &&
            <VariationRequestFacilityLimit2
              isDuringConfirm={isDuringConfirm}
              showCard={isMilestonePassed('facility-limit-2-checked', request)}
            />
          }
          
        </div>
        <div className={styles.column}>
          { !!isMilestonePassed('financial-checked', request) && <VariationReview request={request} disabledModal={isDuringConfirm} /> }
          { !!isMilestonePassed('documents-checked', request) && <VariationRequestForecast disabledModal={isDuringConfirm} /> }
        </div>
      </div>
    </>
  )
}

const CardsStackConfirm = ({request}:{
  request:any
}) => {
  
  const isDuringConfirm = isDuringConfirmProcess(request.status)

  return (
    !isDuringConfirm ? null :
    <>
      <Text mb={24} size="md" weight="medium" style={{color: '#000'}}>
        <Button className='tab' $size='small' $color='charcoal'>
          Variation Confirmed Data
        </Button>
      </Text>
      <BeforeAfterVariation request={request} isConfirm={true} />
      <div className={styles.grid}>
        <div className={styles.column}>
          
          <VariationRequestDetails request={request} isConfirm={true} />
          { !!isMilestonePassed('forecast-confirmed', request) &&
            <VariationRequestEstablishmentFee
              showCard={isMilestonePassed('establish-fee-confirmed', request)}
              isConfirm={true} isDuringConfirm={isDuringConfirm}
            />
          }
          { !!isMilestonePassed('establish-fee-confirmed', request) &&
            <VariationRequestLineFee
              showCard={isMilestonePassed('line-fee-confirmed', request)}
              isConfirm={true} isDuringConfirm={isDuringConfirm}
            />
          }
          { !!isMilestonePassed('line-fee-confirmed', request) &&
            <VariationRequestFacilityLimit2
              showCard={isMilestonePassed('facility-limit-2-confirmed', request)}
              isConfirm={true} isDuringConfirm={isDuringConfirm}
            />
          }
          
          <VariationDataConfirm />
          
        </div>
        <div className={styles.column}>
          { !!isMilestonePassed('financial-confirmed', request) && <VariationReview request={request} isConfirm={true} /> }
          { !!isMilestonePassed('variation-date-confirmed', request)  && <VariationRequestForecast isConfirm={true} /> }
        </div>
      </div>
    </>
  )
}

export default function RequestAboutVariation() {
  const params = useParams()
  const {data: request, isRefetching} = useGetVariationRequest(params.uuid)

  return (
    <>
      <VariationRequestStatusPanel />
      <div className={styles.content}>
        <ProjectCard
          project={request.project}
          request={request}
          isRequestLoading={isRefetching}
          imgHeight={206}
        />
        <div>
          <CardsStackConfirm request={request} />
          <CardsStackRequest request={request} />
        </div>
      </div>
    </>
  )
}
